import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Text, VStack } from '@chakra-ui/react'
import { useShareVehicle, useVehicles } from 'context'
import { ShareVehicleAddContactType } from 'context/ShareVehicle'
import { GenericRouteParamList } from 'router/types'
import { primaryColor } from 'theme/foundations/primaryColor'

import { CardBody, CardContainer } from 'components/CustomCard'
import { SelectedBoxCustom } from 'components/SelectedBoxCustom'
import { customToast } from 'components/ToastCustom'

import { SetAllPermissionIcon, SetNonePermissionIcon } from '../../components/SVGS/newIcons'
import { RequestPermissionsShareVehicleParamList } from '../../router/types'

export const RequestPermissionsShareVehicle = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { icon: { interrogationIconColor, vehicleSecondaryIconColor } } = primaryColor

  const { vehicleState: { state: { vehicle } } } = useVehicles()
  const [isPressed, setIsPressed] = useState<boolean | null>(null)
  const [params, setParams] = useState<RequestPermissionsShareVehicleParamList | null>(null)

  const {
    clearConfirmPin,
    addContactShareVehicle,
    updateContactShareVehicle,
    getContactsShareVehicles,
    clearError,
    shareVehicleState: { loading, error },
  } = useShareVehicle()

  useEffect(() => {
    let params = null

    if (location.state) ({ params } = location.state as GenericRouteParamList<RequestPermissionsShareVehicleParamList>)

    if (params) {
      setParams(params)
      setIsPressed(params.isRestricted ?? null)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleContactsShareVehicles = async () => {
    vehicle?.isPremium && vehicle.isOwner && await getContactsShareVehicles(vehicle.id)
  }

  const handleOnSubmit = async () => {
    if (params && params.previousRoute === 'ADD') {
      const data: ShareVehicleAddContactType = {
        emailInvited: params?.emailInvited ?? '',
        idVehicle: params?.idVehicle ?? '',
        isRestricted: isPressed
      }
      const shareVehicle = await addContactShareVehicle(data)

      if (shareVehicle) {
        handleContactsShareVehicles()
        customToast.showToast({ title: 'Vehículo compartido con:', description: data.emailInvited, status: 'success' })
      }
    } else if (params && params.previousRoute === 'UPDATE')
      if (params.isRestricted !== undefined && params.idInvitation && isPressed !== null) {
        const updatedShareVehicle =
          await updateContactShareVehicle(params.idInvitation, { isRestricted: isPressed })

        if (updatedShareVehicle) {
          handleContactsShareVehicles()

          customToast.showToast({
            title: 'Invitación modificada:',
            description: `${params.emailInvited} ahora tiene 
            ${isPressed ? 'permisos sin ubicación' : 'todos los permisos'}`,
            status: 'success',
          })
        }
      }
    clearConfirmPin()
    navigate('/detail-share-vehicle')
  }

  const handleGoBack = () => {
    navigate('/my-vehicles')
  }

  useEffect(() => {
    if (!vehicle) return handleGoBack()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle])

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <CardContainer
      isScreen
      hiddenStack={false}
      onClose={handleGoBack}
      headerText={'Compartir vehículo '}>
      <CardBody>
        <VStack w={'full'} alignItems={'center'} justifyContent={'center'} spacing={4}>
          <Text variant={'H2'} textAlign={'center'}>Configura los permisos de tu invitado</Text>
          <Text variant={'SM'}>
            Selecciona el acceso que tus invitados tendrán a los distintos servicios de WiCar
          </Text>
          <VStack maxW={{ base: 'full', md: '300px' }} spacing={4}>
            <SelectedBoxCustom
              disabled={loading}
              title='Todos los permisos'
              description={'Tu invitado tendrá acceso a todos los servicios de WiCar.'
                + ' Incluye ubicación e historial de viajes del vehículo.'}
              icon={<SetAllPermissionIcon size={'60px'} />}
              {...isPressed === false && { isSelected: true }}
              handleIsPressed={() => setIsPressed(false)}
            />
            <SelectedBoxCustom
              disabled={loading}
              title='Permisos sin ubicación'
              description={'Tu invitado tendrá acceso a todos los servicios,'
                + ' excepto la ubicación e historial de viajes del vehículo.'}
              icon={<SetNonePermissionIcon size={'60px'}
                fill={interrogationIconColor}
                secondFill={vehicleSecondaryIconColor} />}
              {...isPressed && { isSelected: true }}
              handleIsPressed={() => setIsPressed(true)}
            />
          </VStack>
          <Button
            w={{ base: 'full', md: '300px' }}
            loadingText='Compartiendo...'
            isLoading={loading}
            disabled={isPressed === null || loading}
            onClick={handleOnSubmit}
          >
            {params?.previousRoute === 'ADD' ? ' COMPARTIR' : 'EDITAR'}
          </Button>
        </VStack>
      </CardBody>
    </CardContainer>
  )
}
